export const CONTACTED = 'Contacted';
export const DISQUALIFIED = 'Disqualified';
export const QUOTED = 'Quoted';
export const SOLD = 'Sold';
